// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.JwFh7X {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  background-color: var(--surface-neutral-white);
  position: relative;
  box-sizing: border-box;
  gap: 24px;
  text-align: left;
  font-size: 14px;
  color: var(--text-neutral-dark);
  font-family: var(--font-family-base);
}

.RBZRpD {
  flex: 1;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.KECDuo {
  font-weight: 600;
  font-family: var(--font-family-base);
  color: var(--text-neutral-dark);
  display: flex;
  align-items: center;
  margin: 0;
  padding: 0;
  font-size: 14px;
  line-height: 1.8;
}

.b6_C0R {
  background-color: transparent;
  border-radius: 0;
  padding: 0;
  border: none;
  min-height: auto;
}

.Eqd87Q {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: auto;
}

.h6ZUmv {
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1;
}

.cZ3sQz {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  flex-shrink: 0;
}

.Iicfs7 {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  justify-content: flex-start;
}

.ahm1UL {
  font-size: 14px;
  color: var(--text-neutral-dark, #1f1f1f);
  font-weight: var(--font-weight-semibold, 600);
  font-family: var(--font-family-base);
  line-height: 1.2;
}

.NJ4wxy {
  font-size: 14px;
  color: var(--text-neutral-dark, #1f1f1f);
  font-weight: var(--font-weight-medium, 500);
  font-family: var(--font-family-base);
  line-height: 1.2;
}

.CtI0Dz {
  font-size: 16px;
  color: var(--text-neutral-dark, #1f1f1f);
  font-weight: var(--font-weight-regular, 400);
  font-family: var(--font-family-base);
  line-height: 1.424;
  text-align: right;
  min-width: 140px;
  margin-left: auto;
}

.HJ06fI {
  width: 100%;
  height: 1px;
  background-color: var(--surface-neutral-light, #e6e6e6);
  margin: 0;
  padding: 0;
}

.lveuCg {
  width: 100%;
}

.Fg8TL6 {
  width: 100%;
  height: var(--input-height, 40px);
  border-radius: var(--radius-m, 4px);
}

.z0U2qc {
  width: 100%;
  height: var(--input-height, 40px);
  border-radius: var(--radius-m, 4px);
  border: 1px solid transparent;
  background: transparent;
  font-size: var(--font-size-md, 14px);
  color: var(--text-neutral-dark);
  outline: none;
  transition: border 0.2s;
  font-family: var(--font-family-base);
}

.z0U2qc:focus {
  border-color: var(--surface-primary-medium, #d64000);
  outline-offset: 0;
}

.WUCCPT {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  width: 100%;
  gap: var(--spacing-2, 16px);
  background-color: var(--surface-neutral-white);
  padding: 15px 0 0 0;
}

.KDalDI {
  height: 40px;
  width: 100px;
  padding: var(--spacing-1, 8px) var(--spacing-1-5, 12px);
  border-radius: var(--button-border-radius, 4px);
  background: var(--surface-neutral-white);
  border: 2px solid var(--brand-tr-orange, #d64000);
  color: var(--text-primary-medium, #1f1f1f);
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-semibold, 600);
  font-size: var(--font-size-md, 14px);
  cursor: pointer;
  transition: all 0.2s ease;
}

.KDalDI:hover {
  background: var(--surface-neutral-pale);
}

._woMog {
  height: 40px;
  width: 100px;
  padding: var(--spacing-1, 8px) var(--spacing-1-5, 12px);
  border-radius: var(--button-border-radius, 4px);
  background: var(--brand-tr-orange, #d64000);
  border: 2px solid var(--brand-tr-orange, #d64000);
  color: var(--text-neutral-white, #ffffff);
  cursor: pointer;
  transition: all 0.2s ease;
}

._woMog:hover:not(:disabled) {
  background: var(--brand-tr-orange-dark, #b33600);
  border-color: var(--brand-tr-orange-dark, #b33600);
}

._woMog:disabled {
  opacity: 0.7;
  cursor: not-allowed;
  background: var(--disabled-subtle-surface, #f5f5f5);
  color: var(--text-neutral-strong, #666666);
  border: 2px solid var(--disabled-subtle-surface, #f5f5f5);
}

.Axau7B {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 200px;
  font-size: 16px;
  color: var(--text-neutral-dark, #1f1f1f);
  font-weight: var(--font-weight-regular, 400);
  font-family: var(--font-family-base);
}

.tAQm0J {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 200px;
  font-size: 16px;
  color: var(--text-error, #d32f2f);
  font-weight: var(--font-weight-regular, 400);
  font-family: var(--font-family-base);
  text-align: center;
  padding: 0 20px;
}

@media (max-width: 768px) {
  .JwFh7X {
    padding: 16px;
    gap: 16px;
  }

  .RBZRpD {
    gap: 16px;
  }

  .b6_C0R {
    padding: 0;
    min-height: auto;
  }

  .Eqd87Q {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }

  .CtI0Dz {
    align-self: flex-end;
    min-width: auto;
    margin-left: 0;
  }
}
`, "",{"version":3,"sources":["webpack://./../../packages/pagamentos/src/components/PixTransferValue/PixTransferValue.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,8CAA8C;EAC9C,kBAAkB;EAClB,sBAAsB;EACtB,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,+BAA+B;EAC/B,oCAAoC;AACtC;;AAEA;EACE,OAAO;EACP,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,oCAAoC;EACpC,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,UAAU;EACV,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,UAAU;EACV,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,OAAO;AACT;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,QAAQ;EACR,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,wCAAwC;EACxC,6CAA6C;EAC7C,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,wCAAwC;EACxC,2CAA2C;EAC3C,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,wCAAwC;EACxC,4CAA4C;EAC5C,oCAAoC;EACpC,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,uDAAuD;EACvD,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,iCAAiC;EACjC,mCAAmC;AACrC;;AAEA;EACE,WAAW;EACX,iCAAiC;EACjC,mCAAmC;EACnC,6BAA6B;EAC7B,uBAAuB;EACvB,oCAAoC;EACpC,+BAA+B;EAC/B,aAAa;EACb,uBAAuB;EACvB,oCAAoC;AACtC;;AAEA;EACE,oDAAoD;EACpD,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,WAAW;EACX,2BAA2B;EAC3B,8CAA8C;EAC9C,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,uDAAuD;EACvD,+CAA+C;EAC/C,wCAAwC;EACxC,iDAAiD;EACjD,0CAA0C;EAC1C,oCAAoC;EACpC,6CAA6C;EAC7C,oCAAoC;EACpC,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,uDAAuD;EACvD,+CAA+C;EAC/C,2CAA2C;EAC3C,iDAAiD;EACjD,yCAAyC;EACzC,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,gDAAgD;EAChD,kDAAkD;AACpD;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,mDAAmD;EACnD,0CAA0C;EAC1C,yDAAyD;AAC3D;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,wCAAwC;EACxC,4CAA4C;EAC5C,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,iCAAiC;EACjC,4CAA4C;EAC5C,oCAAoC;EACpC,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE;IACE,aAAa;IACb,SAAS;EACX;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,UAAU;IACV,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,oBAAoB;IACpB,eAAe;IACf,cAAc;EAChB;AACF","sourcesContent":[".container {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  height: 100%;\n  background-color: var(--surface-neutral-white);\n  position: relative;\n  box-sizing: border-box;\n  gap: 24px;\n  text-align: left;\n  font-size: 14px;\n  color: var(--text-neutral-dark);\n  font-family: var(--font-family-base);\n}\n\n.content {\n  flex: 1;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n\n.title {\n  font-weight: 600;\n  font-family: var(--font-family-base);\n  color: var(--text-neutral-dark);\n  display: flex;\n  align-items: center;\n  margin: 0;\n  padding: 0;\n  font-size: 14px;\n  line-height: 1.8;\n}\n\n.balanceCard {\n  background-color: transparent;\n  border-radius: 0;\n  padding: 0;\n  border: none;\n  min-height: auto;\n}\n\n.balanceInfo {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  height: auto;\n}\n\n.balanceIcon {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex: 1;\n}\n\n.iconContainer {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n  height: 24px;\n  flex-shrink: 0;\n}\n\n.balanceText {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 8px;\n  justify-content: flex-start;\n}\n\n.balanceLabel {\n  font-size: 14px;\n  color: var(--text-neutral-dark, #1f1f1f);\n  font-weight: var(--font-weight-semibold, 600);\n  font-family: var(--font-family-base);\n  line-height: 1.2;\n}\n\n.accountType {\n  font-size: 14px;\n  color: var(--text-neutral-dark, #1f1f1f);\n  font-weight: var(--font-weight-medium, 500);\n  font-family: var(--font-family-base);\n  line-height: 1.2;\n}\n\n.balanceAmount {\n  font-size: 16px;\n  color: var(--text-neutral-dark, #1f1f1f);\n  font-weight: var(--font-weight-regular, 400);\n  font-family: var(--font-family-base);\n  line-height: 1.424;\n  text-align: right;\n  min-width: 140px;\n  margin-left: auto;\n}\n\n.divider {\n  width: 100%;\n  height: 1px;\n  background-color: var(--surface-neutral-light, #e6e6e6);\n  margin: 0;\n  padding: 0;\n}\n\n.valueInput {\n  width: 100%;\n}\n\n.inputContainer {\n  width: 100%;\n  height: var(--input-height, 40px);\n  border-radius: var(--radius-m, 4px);\n}\n\n.input {\n  width: 100%;\n  height: var(--input-height, 40px);\n  border-radius: var(--radius-m, 4px);\n  border: 1px solid transparent;\n  background: transparent;\n  font-size: var(--font-size-md, 14px);\n  color: var(--text-neutral-dark);\n  outline: none;\n  transition: border 0.2s;\n  font-family: var(--font-family-base);\n}\n\n.input:focus {\n  border-color: var(--surface-primary-medium, #d64000);\n  outline-offset: 0;\n}\n\n.footer {\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-end;\n  width: 100%;\n  gap: var(--spacing-2, 16px);\n  background-color: var(--surface-neutral-white);\n  padding: 15px 0 0 0;\n}\n\n.backButton {\n  height: 40px;\n  width: 100px;\n  padding: var(--spacing-1, 8px) var(--spacing-1-5, 12px);\n  border-radius: var(--button-border-radius, 4px);\n  background: var(--surface-neutral-white);\n  border: 2px solid var(--brand-tr-orange, #d64000);\n  color: var(--text-primary-medium, #1f1f1f);\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-semibold, 600);\n  font-size: var(--font-size-md, 14px);\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.backButton:hover {\n  background: var(--surface-neutral-pale);\n}\n\n.nextButton {\n  height: 40px;\n  width: 100px;\n  padding: var(--spacing-1, 8px) var(--spacing-1-5, 12px);\n  border-radius: var(--button-border-radius, 4px);\n  background: var(--brand-tr-orange, #d64000);\n  border: 2px solid var(--brand-tr-orange, #d64000);\n  color: var(--text-neutral-white, #ffffff);\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.nextButton:hover:not(:disabled) {\n  background: var(--brand-tr-orange-dark, #b33600);\n  border-color: var(--brand-tr-orange-dark, #b33600);\n}\n\n.nextButton:disabled {\n  opacity: 0.7;\n  cursor: not-allowed;\n  background: var(--disabled-subtle-surface, #f5f5f5);\n  color: var(--text-neutral-strong, #666666);\n  border: 2px solid var(--disabled-subtle-surface, #f5f5f5);\n}\n\n.loading {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 200px;\n  font-size: 16px;\n  color: var(--text-neutral-dark, #1f1f1f);\n  font-weight: var(--font-weight-regular, 400);\n  font-family: var(--font-family-base);\n}\n\n.error {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 200px;\n  font-size: 16px;\n  color: var(--text-error, #d32f2f);\n  font-weight: var(--font-weight-regular, 400);\n  font-family: var(--font-family-base);\n  text-align: center;\n  padding: 0 20px;\n}\n\n@media (max-width: 768px) {\n  .container {\n    padding: 16px;\n    gap: 16px;\n  }\n\n  .content {\n    gap: 16px;\n  }\n\n  .balanceCard {\n    padding: 0;\n    min-height: auto;\n  }\n\n  .balanceInfo {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 12px;\n  }\n\n  .balanceAmount {\n    align-self: flex-end;\n    min-width: auto;\n    margin-left: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `JwFh7X`,
	"content": `RBZRpD`,
	"title": `KECDuo`,
	"balanceCard": `b6_C0R`,
	"balanceInfo": `Eqd87Q`,
	"balanceIcon": `h6ZUmv`,
	"iconContainer": `cZ3sQz`,
	"balanceText": `Iicfs7`,
	"balanceLabel": `ahm1UL`,
	"accountType": `NJ4wxy`,
	"balanceAmount": `CtI0Dz`,
	"divider": `HJ06fI`,
	"valueInput": `lveuCg`,
	"inputContainer": `Fg8TL6`,
	"input": `z0U2qc`,
	"footer": `WUCCPT`,
	"backButton": `KDalDI`,
	"nextButton": `_woMog`,
	"loading": `Axau7B`,
	"error": `tAQm0J`
};
module.exports = ___CSS_LOADER_EXPORT___;
